/** @format */

import { createAction, props } from '@ngrx/store';
import { ProductSelectionState } from '@pdp/data-access/interfaces';

export const appInitializerKillswitchesSet = createAction(
  '[PDP App Initializer] Set Killswitches',
  props<{ killswitches: ProductSelectionState['killswitches'] }>(),
);
